import styled, {
  DefaultTheme,
  css,
  FlattenSimpleInterpolation
} from 'styled-components'

const templatesModifiers: TemplatesModifiers<
  DefaultTheme,
  FlattenSimpleInterpolation
> = {
  primary: () => css`
    background: color-mix(in srgb, var(--primary) 10%, transparent);
    color: var(--primary);
    border: none;
  `,
  primaryDark: () => css`
    background: var(--primary);
    color: white;
    border: none;
  `,
  success: () => css`
    background: var(--sl-color-green-3);
    border: none;
  `,
  successSolid: () => css`
    background: var(--sl-color-green-10);
    color: white;
    border: none;

    * {
      color: white;
    }
  `,
  danger: () => css`
    background: var(--sl-color-red-3);
    border: none;
  `,
  info: () => css`
    background: var(--sl-color-blue-3);
    border: none;
  `,
  warning: () => css`
    background: var(--sl-color-yellow-3);
    border: none;
  `
}

export const Badge = styled.span<PropsBadge>`
  background: transparent;
  border: 0;
  outline: 0;

  ${({ theme, template }) => css`
    --padding: 0.25rem 0.75rem;
    --borderRadius: 0.25rem;
    --fontSize: 0.75rem;
    --fontWeight: ${theme.font.medium};
    --iconFontSize: 0.875rem;

    &.Badge_UI_Component_small {
      --padding: 0.125rem 0.25rem;
      --borderRadius: 0.125rem;
      --fontSize: 0.625rem;
      --fontWeight: ${theme.font.bold};
      --iconFontSize: 0.625rem;

      line-height: 1;
      letter-spacing: -0.125px;
      text-transform: uppercase;
    }

    &.Badge_UI_Component_tiny {
      --padding: 0.125rem 0.25rem;
      --borderRadius: 0.125rem;
      --fontSize: 0.5rem;
      --fontWeight: ${theme.font.bold};
      --iconFontSize: 0.75rem;

      line-height: 1.25;
      letter-spacing: 1px;
      text-transform: uppercase;
    }

    display: inline-flex;
    justify-content: flex-start;
    align-items: center;

    margin: 0.125rem 0.25rem 0.125rem 0;
    padding: var(--padding);

    border-radius: var(--borderRadius);
    border: 1px solid var(--sl-color-gray-2);

    background: var(--sl-color-gray-1);

    color: var(--sl-fg-base);
    font-size: var(--fontSize);
    font-weight: var(--fontWeight);

    white-space: nowrap;
    text-overflow: ellipsis;

    .icon__left {
      display: inline-flex;
      margin-right: 0.25rem;
      font-size: var(--iconFontSize);
    }

    ${templatesModifiers[template]?.(theme)}
  `}
`
